module.exports = __webpack_public_path__ + "static/features-slide4-42fd701d73e9ea48f8425b07f33b6e7e.png";